import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paper } from "@mui/material";
import { logEvent, logException } from "../../helper/AppInsightsHelper";
import { DATA_GRID_SLOTS } from "../../BasicComponents/DataGridSlots";
import { useGetFavoriteProductsByLoginQuery } from "../../slices/ExploreProducts.slice";

export default function FavoriteProductsGridComponent() {
  const [rows, setRows] = useState<GridRowsProp>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { data, error } = useGetFavoriteProductsByLoginQuery({});

  const columns: GridColDef[] = [
    {
      headerName: "Product Name",
      field: "latestProductName",
      width: 300,
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <a
          href="#"
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 12,
            cursor: "pointer"
          }}
          tabIndex={0}
          onClick={() => {
            navigate(
              "/productview?productid=" +
                encodeURIComponent(params.row.productId) +
                "&productname=" +
                encodeURIComponent(params.row.latestProductName)
            );
          }}
        >
          {params.row.latestProductName}
        </a>
      )
    },
    {
      headerName: "Product Family",
      field: "productFamily",
      width: 300,
      sortable: false
    },
    {
      headerName: "Favorite Status",
      field: "isFavorite",
      width: 300,
      sortable: false,
      renderCell: (params) => <span>{params.value ? "⭐ Favorite" : "Not Favorite"}</span>
    }
  ];

  useEffect(() => {
    setLoading(true);
    if (data) {
      setRows(data);
      setLoading(false);

      logEvent("getFavoriteProductsByLogin API call success", "My Favorites", "FavoriteProductsGridComponent");
    }
    if (error) {
      setLoading(false);
      logException("My Favorites", "FavoriteProductsGridComponent", "getFavoriteProductsByLogin", error);
    }
  }, [data, error]);

  return (
    <Paper>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.productId}
        loading={loading}
        keepNonExistentRowsSelected
        hideFooterPagination
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableRowSelectionOnClick
        disableColumnSelector
        slots={{
          loadingOverlay: DATA_GRID_SLOTS.loadingOverlay,
          noRowsOverlay: DATA_GRID_SLOTS.noFavoriteProductsOverlay(!!error)
        }}
      />
    </Paper>
  );
}
